module.exports = __webpack_public_path__ + "static/media/cycle.2311783c.png";